"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RestateProvider = void 0;
const React = require("react");
const react_redux_1 = require("react-redux");
const restate_core_1 = require("@agilepoint/restate-core");
const store_context_1 = require("./store-context");
function RestateProvider(props) {
    const { store, children, onBuildIocContainer, plugins } = props;
    const restateStore = React.useMemo(() => (0, restate_core_1.createRestate)({ store, onBuildIocContainer, plugins }), [store, onBuildIocContainer]);
    return (React.createElement(store_context_1.RestateContext.Provider, { value: restateStore },
        React.createElement(react_redux_1.Provider, { store: store }, children)));
}
exports.RestateProvider = RestateProvider;
//# sourceMappingURL=restate-provider.js.map